import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import { signOut } from "store/slices/authSlice";
import { AUTH_TOKEN } from "constants/AuthConstant";
import { notification } from "antd";
import store from "store";
import { isMoreThan12HoursPassed } from "utils/DateTimeUtil";
const unauthenticatedCode = [401];

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

// Config
const TOKEN_PAYLOAD_KEY = "authorization";

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const jwtToken = "Bearer " + localStorage.getItem(AUTH_TOKEN) || null;

    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = jwtToken;
    }
    config.headers["Accept"] = "application/json";
    if (
      config.url &&
      (config.url.includes("/results") || config.url.includes("/upload"))
    ) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    // Do something with request error here
    notification.error({
      message: "Error",
    });
    Promise.reject(error);
  }
);

// API respone interceptor
service.interceptors.response.use(
  (response) => {
    if (isMoreThan12HoursPassed()) {
      store.dispatch(signOut());
      return null;
    }
    return response.data;
  },
  (error) => {
    if (unauthenticatedCode.includes(error.response.status)) {
      store.dispatch(signOut());
    }

    return Promise.reject(error);
  }
);

export default service;
